import { Injectable } from '@angular/core';
import { fabric } from 'fabric';

@Injectable({
  providedIn: 'root'
})

export class CanvasService {

  constructor() { }

  // #region "Draw"

  // addTextToCanvas() - Add textbox to canvas image
  addTextToCanvas(canvasObj:any): void {
    canvasObj.add(new fabric.IText('Enter text here'));
  }

  // addCircleToCanvas() - Add circle shape to canvas image
  addCircleToCanvas(canvasObj:any, shapeBorderColor:string, shapeStroke:string, shapeStrokeWidth:number): void {
   canvasObj.add(new fabric.Circle({ radius: 30, borderColor: shapeBorderColor, fill: 'transparent', stroke: shapeStroke, strokeWidth: shapeStrokeWidth }));
  }

  // addRectangleToCanvas() - Add rectangle shape to canvas image
  addRectangleToCanvas(canvasObj:any, shapeBorderColor:string, shapeStroke:string, shapeStrokeWidth:number): void {
   canvasObj.add(new fabric.Rect({ borderColor: shapeBorderColor, width: 50, height: 50, stroke: shapeStroke, strokeWidth: shapeStrokeWidth, fill: 'transparent' }));
  }

  // addArrowToCanvas() - Add arrow shape to canvas image
  addArrowToCanvas(canvasObj:any, shapeStroke:string, shapeStrokeWidth:number): void {
    let fromx = 0, fromy = 90, tox = 100, toy = 90;
    var angle = Math.atan2(toy - fromy, tox - fromx);

    var headlen = 40;  // arrow head size
    var divideBy = 2;

    // bring the line end back some to account for arrow head.
    tox = tox - (headlen) * Math.cos(angle);
    toy = toy - (headlen) * Math.sin(angle);


    var points = [
      {
        x: fromx,  // start point
        y: fromy
      }, {
        x: fromx - (headlen / divideBy) * Math.cos(angle - Math.PI / 2),
        y: fromy - (headlen / divideBy) * Math.sin(angle - Math.PI / 2)
      }, {
        x: tox - (headlen / divideBy) * Math.cos(angle - Math.PI / 2),
        y: toy - (headlen / divideBy) * Math.sin(angle - Math.PI / 2)
      }, {
        x: tox - (headlen) * Math.cos(angle - Math.PI / 2),
        y: toy - (headlen) * Math.sin(angle - Math.PI / 2)
      }, {
        x: tox + (headlen) * Math.cos(angle),  // tip
        y: toy + (headlen) * Math.sin(angle)
      }, {
        x: tox - (headlen) * Math.cos(angle + Math.PI / 2),
        y: toy - (headlen) * Math.sin(angle + Math.PI / 2)
      }, {
        x: tox - (headlen / divideBy) * Math.cos(angle + Math.PI / 2),
        y: toy - (headlen / divideBy) * Math.sin(angle + Math.PI / 2)
      }, {
        x: fromx - (headlen / divideBy) * Math.cos(angle + Math.PI / 2),
        y: fromy - (headlen / divideBy) * Math.sin(angle + Math.PI / 2)
      }, {
        x: fromx,
        y: fromy
      }
    ];

    var pline = new fabric.Polyline(points, {
      fill: 'transparent',
      stroke: shapeStroke,
      opacity: 1,
      strokeWidth: shapeStrokeWidth,
      originX: 'left',
      originY: 'top',
      selectable: true,
      height: 25,
      width: 25
    });

    canvasObj.add(pline);
  }

  // fillColor() - Fill color of shape
  fillColor(canvasObj:any, shapeFillColor:string): void {
    canvasObj.getActiveObject().set('fill', shapeFillColor);
    canvasObj.renderAll();
  }

  // changeFillColor() - Change fill color of active object
  changeFillColor(event: string, data: any, canvas: any, shapeFillColor:string): void {
    if(canvas.getActiveObject()){
      this.fillColor(canvas, shapeFillColor);
    }
  }

  // changeBorderColor() - Change border color of active object.
  changeBorderColor(event: string, data: any, canvas: any, shapeStroke:string): void {
    if(canvas.getActiveObject()){
      canvas.getActiveObject().set('stroke', shapeStroke);
      canvas.renderAll();
    }
  }

  // removeObject() - Remove active element
  removeObject(canvas: any): void {
    canvas.remove(canvas.getActiveObject());
  }

  // downloadImg() - Download image
  downloadImg = function(el, canvasObj): void {
    let image = canvasObj.toDataURL();
    var link = document.createElement('a');
    link.download = 'my-image.png';
    link.href = image;
    link.click();
  };

  // #endregion
}
